var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { hoverMediaQuery, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
const hoverStyles = css(["&:hover{max-width:200px;transition-delay:0s;}"]);
export const IconAction = styled.span.withConfig({
  displayName: "IconAction",
  componentId: "sc-18we0kp-0"
})(["display:", ";position:relative;align-items:center;flex-shrink:0;overflow:hidden;min-width:36px;max-width:", ";height:36px;padding-right:", ";border-radius:", ";margin-left:9px;cursor:pointer;", ";", ";font-weight:500;", " white-space:nowrap;color:#fff;transition:max-width 0.25s ease;transition-delay:0.25s;", ";a{line-height:36px;}> svg{position:absolute;top:50%;left:0;transform:translateY(-50%) translateX(18px) translateX(-50%);}", ";", ";", ";"], _ref => {
  let {
    showMobile
  } = _ref;
  return showMobile ? 'none' : 'flex';
}, _ref2 => {
  let {
    opened
  } = _ref2;
  return opened ? '200px' : '36px';
}, _ref3 => {
  let {
    noPadding
  } = _ref3;
  return noPadding ? '0px' : '9px';
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.borderRadius;
}, _ref5 => {
  let {
    withBackground = true
  } = _ref5;
  return withBackground && css(["background:", ";"], _ref6 => {
    let {
      theme,
      backgroundColor
    } = _ref6;
    return backgroundColor === 'secondary' ? theme.secondaryColor : 'rgba(255, 255, 255, 0.1)';
  });
}, getFont(0), fontSmoothing, _ref7 => {
  let {
    as
  } = _ref7;
  return as === 'a' ? hoverMediaQuery(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), hoverStyles) : hoverStyles;
}, maxMediaQueries.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n  "])), _ref8 => {
  let {
    $hideMobile
  } = _ref8;
  return $hideMobile && 'display: none;';
}, _ref9 => {
  let {
    showMobile
  } = _ref9;
  return showMobile && 'display: flex;';
}), maxMediaQueries.miniDesktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n  "])), _ref10 => {
  let {
    $hideMobile
  } = _ref10;
  return $hideMobile && 'display: none;';
}), maxMediaQueries.desktop(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n  "])), _ref11 => {
  let {
    $hideTablet
  } = _ref11;
  return $hideTablet && 'display: none;';
}));
export const IconActionText = styled.span.withConfig({
  displayName: "IconAction__IconActionText",
  componentId: "sc-18we0kp-1"
})(["margin-left:36px;color:#fff;"]);
export const Action = styled.span.withConfig({
  displayName: "IconAction__Action",
  componentId: "sc-18we0kp-2"
})(["display:flex;align-items:center;justify-content:center;min-width:fit-content;height:36px;border-radius:", ";cursor:pointer;color:#fff;padding:0 16px;margin-left:9px;background:", ";"], _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.borderRadius;
}, _ref13 => {
  let {
    theme
  } = _ref13;
  return theme.plus.background;
});